import React, { useEffect, useMemo, useState } from "react";
import styles from "../../styles/Docs/Docs.module.css";
// import MediaQuery from "react-responsive";
import stylesSelect from "../../styles/Select.module.css";

import { useAppDispatch, useAppSelector } from "../../hooks";
import { getAttributes } from "../../actions/attributes";
import {
  AutocompleteInputCustom,
  OptionAutocompleteInputCustom,
} from "../inputs/AutocompleteInputCustom";
import {
  //Edit,
  Clean,
} from "../../../public/icons";
import {
  editTypes,
  getTypes,
  TYPES_EDIT_RESET,
  TYPES_RESET,
} from "../../actions/types";
import { CheckboxGroup } from "../inputs/Checkbox";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { AlertTooltip } from "../Spreadsheet/ModTooltip";
import { BtnWrapper } from "../../styles/Docs/DocsToolbar.styled";
import { DotsLoader } from "../Loaders/Loader";

interface MandatoryAttrs {
  id: string;
  mandatory: boolean;
}

interface TypeWithAttrs {
  id: string;
  title: string;
  attributes: MandatoryAttrs[];
}

export default function DocTypes() {
  const dispatch = useAppDispatch();
  const types = useAppSelector((state) => state.types);
  const editTypesState = useAppSelector((state) => state.editTypes);
  const attributesCommon = useAppSelector((state) => state.attributes);
  const user = useAppSelector((state) => state.user);
  const [error, setError] = useState("");
  const filteredArrayTypes = (types?.list || [])
    .filter((el: any) => el?.attributes?.length > 0)
    .sort((a:any, b:any) => a.title.localeCompare(b.title));

  const [typesWhithMandatoryAttr, setTypesWhithMandatoryAttr] = useState<
    TypeWithAttrs[]
  >([]);
  const [selectedAttrs, setSelectedAttrs] = useState<MandatoryAttrs[]>([]);
  const [currentTypeId, setCurrentTypeId] = useState<string | null>(null);

  const sortedAttributesCommon = Object.fromEntries(
    (attributesCommon.list || [])
      .slice()
      .sort((a: any, b: any) => (a.title || "").localeCompare(b.title || ""))
      .map((attr: any) => [attr.id, attr.title]),
  );

  const busyIds = useMemo(() => {
    return new Set(
      typesWhithMandatoryAttr
        .map((item) => item.id)
        .filter((id) => id && !id.startsWith("new_")),
    );
  }, [typesWhithMandatoryAttr]);

  const optionsForAutocomplete = useMemo(() => {
    return (types?.list || []).map((type: any) => ({
      ...type,
      isDisabled: busyIds.has(type.id),
    }));
  }, [types.list, busyIds]);

  // const handleChangeSelectedType = (
  //   opt: OptionAutocompleteInputCustom | OptionAutocompleteInputCustom[] | null,
  //   rowId: string,
  // ) => {
  //   if (!opt || Array.isArray(opt)) {
  //     setCurrentTypeId("");
  //     return;
  //   }
  //   if (!opt.id) return;

  //   const newId = String(opt.id);

  //   const alreadyUsed = typesWhithMandatoryAttr.some(
  //     (item) => item.id === newId && item.id !== rowId,
  //   );

  //   if (alreadyUsed) {
  //     setError("Такий тип документу вже додано");
  //     return;
  //   }

  //   setError("");
  //   setCurrentTypeId(newId);

  //   setTypesWhithMandatoryAttr((prev) =>
  //     prev.map((item) =>
  //       item.id === rowId ? { ...item, id: newId, title: opt.title } : item,
  //     ),
  //   );
  // };


const handleChangeSelectedType = (
  opt: OptionAutocompleteInputCustom | OptionAutocompleteInputCustom[] | null,
  rowId: string,
) => {
  if (!opt || Array.isArray(opt)) {
    setCurrentTypeId("");
    return;
  }
  if (!opt.id) return;

  const newId = String(opt.id);

  const alreadyUsed = typesWhithMandatoryAttr.some(
    (item) => item.id === newId && item.id !== rowId,
  );

  if (alreadyUsed) {
    setError("Такий тип документу вже додано");
    return;
  }

  setError("");

  const oldRow = typesWhithMandatoryAttr.find((item) => item.id === rowId);
  const inheritedAttributes = oldRow?.attributes ?? [];

  if (oldRow?.id && !oldRow.id.startsWith("new_")) {
    dispatch(editTypes(oldRow.id, { attributes: [] }));
  }

  setCurrentTypeId(newId);
  setSelectedAttrs(inheritedAttributes);

  setTypesWhithMandatoryAttr((prev) =>
    prev.map((item) =>
      item.id === rowId
        ? { ...item, id: newId, title: opt.title, attributes: inheritedAttributes }
        : item,
    ),
  );
};

  const handleCleanUpType = (el: string) => {
    
    if (el.startsWith("new_")) return;

    dispatch(editTypes(el, { attributes: [] }));

    setTypesWhithMandatoryAttr((prev) =>
      prev.map((item) => (item.id === el ? { ...item, attributes: [] } : item)),
    );
  };

  useEffect(() => {
    return () => {
      dispatch({ type: TYPES_RESET });
    };
  }, [dispatch]);

  useEffect(() => {
    if (types.state === "success") {
      setTypesWhithMandatoryAttr(filteredArrayTypes);
    }
  }, [types.state, types.list]);

  useEffect(() => {
    if (types.state === "idle") {
      dispatch(getTypes());
    }
  }, [dispatch, types]);

  useEffect(() => {
    if (attributesCommon.state === "idle") {
      dispatch(getAttributes(null));
    }
  }, [dispatch, attributesCommon]);

  useEffect(() => {
    if (!currentTypeId) return;
    const data = { attributes: selectedAttrs ?? [] };
    dispatch(editTypes(currentTypeId, data));
  }, [selectedAttrs, currentTypeId]);

  useEffect(() => {
    if (editTypesState.state === "success") {
      dispatch({ type: TYPES_EDIT_RESET });
      setSelectedAttrs([]);
      setCurrentTypeId("");
    }

    if (editTypesState.state === "failure") {
      setError(editTypesState.result.message);
    }
  }, [editTypesState]);


  return (
    <>
      <section
        className={`${styles.wrapper} ${styles.settings}`}
        style={{ padding: "20px", overflow: "auto" }}
      >
        <div
          style={{
            fontSize: "20px",
            fontWeight: "700",
            marginBottom: "20px",
          }}
        >
          Налаштування функцій
        </div>
        {user.permissions["document-type.update"] && (
          <div
            style={{
              backgroundColor: "var(--background)",
              padding: "16px",
              borderRadius: "20px",
              display: "flex",
              flexDirection: "column",
              gap: "20px",
            }}
          >
            <div style={{ fontSize: "16px", fontWeight: "700" }}>
              Обовязкові атрибути для вхідних документів
            </div>

            {types.state === "loading" && !typesWhithMandatoryAttr.length && (
              <div style={{ display: "flex", justifyContent: "center", padding: "40px 0" }}>
                <DotsLoader scale={0.6} />
              </div>
            )}
            {Array.isArray(typesWhithMandatoryAttr) &&
              typesWhithMandatoryAttr.length > 0 &&
              typesWhithMandatoryAttr.map((el: any) => {
                return (
                  <div key={el.id} className={stylesSelect.doc_type_page_list}>
                    <AutocompleteInputCustom
                      label={"Тип документу"}
                      value={el.id}
                      options={optionsForAutocomplete}
                      onChange={(opt) => handleChangeSelectedType(opt, el.id)}
                      placeholder="Оберіть або введіть"
                      labelStyle={{
                        background:
                          "linear-gradient(to bottom, var(--background) 40%, white 60%)",
                      }}
                      width={"300px"}
                      style={{ flexShrink: 0 }}
                    />

                    <div>
                      {attributesCommon.list && (
                        <CheckboxGroup
                          options={sortedAttributesCommon}
                          value={
                            el.attributes
                              ? el.attributes.map((a: any) => a.id)
                              : []
                          }
                          onChange={(selected: string | string[]) => {
                            setCurrentTypeId(el.id);

                            const selectedArray = Array.isArray(selected)
                              ? selected
                              : [selected];
                            setSelectedAttrs(
                              selectedArray.map((id) => ({
                                id: id,
                                mandatory: true,
                              })),
                            );
                            setTypesWhithMandatoryAttr((prev) =>
                              prev.map((item) =>
                                item.id === el.id
                                  ? {
                                      ...item,
                                      attributes: selectedArray.map((id) => ({
                                        id,
                                        mandatory: true,
                                      })),
                                    }
                                  : item,
                              ),
                            );
                          }}
                          label={""}
                          border={false}
                          row={true}
                        />
                      )}
                    </div>

                    <AlertTooltip title="Очистити вибірку">
                      <BtnWrapper
                        $width="32px"
                        $height={"32px"}
                        $bgColor="var(--sidebar-hover)"
                        onClick={() => {
                          handleCleanUpType(el.id);
                        }}
                      >
                        <Clean
                          height={"32px"}
                          width={"26px"}
                          color="var(--blue)"
                        />
                      </BtnWrapper>
                    </AlertTooltip>
                  </div>
                );
              })}

            <button
              className={stylesSelect.addBtn}
              onClick={() => {
                setTypesWhithMandatoryAttr((prev) => [
                  ...prev,
                  { id: `new_${Date.now()}`, title: "", attributes: [] },
                ]);
              }}
            >
              <div className={stylesSelect.plusIcon}>
                <AddCircleIcon
                  sx={{ height: "40px", width: "40px", color: "#E4ECFF" }}
                />
              </div>
              <span>Додати тип документу</span>
            </button>
            <div>{error}</div>
          </div>
        )}
      </section>
    </>
  );
}
